module.exports = __webpack_public_path__ + "static/media/3.aa12a6b1.png";